module.exports = __webpack_public_path__ + "static/media/TOMB.f2b44ef4.svg";